import { useTranslation } from 'react-i18next'

import { Icon } from '@/shared/components/icon'
import { Button } from '@/shared/components/ui'

interface IEmConstrucaoPageProps {
  nome: string
}

export const EmConstrucaoPage = ({ nome }: IEmConstrucaoPageProps) => {
  const { t } = useTranslation('common')

  return (
    <div data-testid="em-construcao-page" className="flex min-h-[80vh] flex-col items-center justify-center px-4">
      <div className="flex max-w-md flex-col items-center text-center">
        <div className="bg-muted mb-6 flex h-24 w-24 items-center justify-center rounded-full">
          <Icon name="user" className="text-muted-foreground h-12 w-12" />
        </div>
        <h1 className="mb-2 text-2xl font-bold">@{nome}</h1>
        <p className="text-muted-foreground mb-6">{t('em_construcao.titulo')}</p>
        <div className="mb-8 w-full space-y-2">
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">{t('em_construcao.progresso')}</span>
            <span className="text-muted-foreground flex items-center gap-2">
              <Icon name="timer" className="h-4 w-4" />
              <span>{t('em_construcao.em_breve')}</span>
            </span>
          </div>
          <div className="mb-4 h-2 w-full rounded-full bg-gray-200 dark:bg-gray-700">
            <div className="h-2 rounded-full bg-gray-600 dark:bg-gray-300" style={{ width: '10%' }} />
          </div>
        </div>
        <Button disabled className="gap-2">
          <Icon name="loader" className="h-4 w-4 animate-spin" data-testid="loader-icon" />
          {t('em_construcao.em_construcao')}...
        </Button>
      </div>
    </div>
  )
}
